/* eslint-disable react-refresh/only-export-components */

import { lazy } from "react";
import { createBrowserRouter } from "react-router-dom";

import App from "./App";
import { ProtectedRoute } from "./routes/ProtectedRoute";

const Home = lazy(() =>
  import("./routes/Home/Home").then((m) => ({
    default: m.Home,
  })),
);

const Terms = lazy(() =>
  import("./routes/Terms/Terms").then((m) => ({
    default: m.Terms,
  })),
);

const Contato = lazy(() =>
  import("./routes/Contact/Contact").then((m) => ({
    default: m.Contato,
  })),
);

const About = lazy(() =>
  import("./routes/About/About").then((m) => ({
    default: m.About,
  })),
);

const Login = lazy(() =>
  import("./routes/account/Login").then((m) => ({
    default: m.Login,
  })),
);

const Occupation = lazy(() =>
  import("./routes/Occupation/Occupation").then((m) => ({
    default: m.Occupation,
  })),
);

const News = lazy(() => import("./routes/News/News"));

const Consumer = lazy(() => import("./routes/Occupation/Consumer/Consumer"));

const Air = lazy(() => import("./routes/Occupation/Air/Air"));

const Digital = lazy(() => import("./routes/Occupation/Digital/Digital"));

const Social = lazy(() => import("./routes/Occupation/Social/Social"));

const Dashboard = lazy(() =>
  import("./routes/Dashboard/Dashboard").then((m) => ({
    default: m.Dashboard,
  })),
);

const Privacy = lazy(() =>
  import("./routes/Privacy/Privacy").then((m) => ({
    default: m.Privacy,
  })),
);

const NewsPage = lazy(() => import("./routes/News/NewsPage"));

const ResetPasswordPage = lazy(() =>
  import("./routes/account/ResetPasswordPage").then((m) => ({
    default: m.ResetPasswordPage,
  })),
);

const DataDeletion = lazy(() => import("./routes/DateDeletion/DataDeletion"));

// const LandingPage = lazy(() =>
//   import("./routes/Landing/LandingPage").then((m) => ({
//     default: m.LandingPage,
//   }))
// );

const LinktreeCard = lazy(() => import("./routes/Linktree/LinktreeCard"));

const SocialSecurity = lazy(() => import("./routes/Occupation/SocialSecurity/SocialSecurity"));

const Planning = lazy(() => import("./routes/Occupation/Planning/Planning"));

export const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      { path: "/", element: <Home /> },
      { path: "/escritorio", element: <About /> },
      { path: "/terms", element: <Terms /> },
      { path: "/politica-privacidade", element: <Privacy /> },
      { path: "/contato", element: <Contato /> },
      { path: "/login", element: <Login /> },
      { path: "/resetar-senha", element: <ResetPasswordPage /> },
      { path: "/area-atuacao", element: <Occupation /> },
      { path: "/noticias", element: <News /> },
      { path: "/direito-consumidor", element: <Consumer /> },
      { path: "/direito-aereo", element: <Air /> },
      { path: "/direito-digital", element: <Digital /> },
      { path: "/direito-saude", element: <Social /> },
      { path: "/direito-previdenciario", element: <SocialSecurity /> },
      { path: "/planejamento-previdenciario", element: <Planning /> },
      // { path: "/landing-page", element: <LandingPage /> },
      {
        path: "/dashboard",
        element: (
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        ),
      },
      { path: "/deletar-dados", element: <DataDeletion /> },
      { path: "/pagina-noticias", element: <NewsPage /> },
      { path: "/links", element: <LinktreeCard /> },
    ],
  },
]);
